<template>
  <div v-if="usuario" >
    <v-container grid-list-md text-xs-left class="pa-0">
      <!-- Personal Data -->
      <v-layout row wrap class="mt-2">
        <v-flex xs12>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`pointer-card mx-auto elevation-${hover ? 12 : 2}`"
              :color="`${hover ? 'amber lighten-5' : 'grey lighten-4'}`"
              max-width="600"
              @click="clickEdit('personalData')"
            >
              <v-card-text class="grey--text text--darken-2 font-weight-light">
                <h2 class="headline font-weight-light text-xs-right">Datos Personales</h2>
                <v-divider></v-divider>
                <p class="headline blue--text font-weight-thin mt-3">{{ usuarioFormated.nombre }}</p>
                <p style="line-height:29px">
                  <v-icon size="18" class="blue--text mr-2">mdi-map-marker</v-icon> <span class="blue--text">Dirección:</span><span :class="`${usuarioFormated.direccion === 'Sin especificar' ? 'red--text' : ''}`"> {{ usuarioFormated.direccion }}</span><br>
                  <v-icon size="18" class="blue--text mr-2">mdi-label</v-icon> <span class="blue--text">NIF/NIE:</span><span :class="`${usuarioFormated.nif === 'Sin especificar' ? 'red--text' : ''}`"> {{ usuarioFormated.nif }}</span><br>
                  <v-icon size="18" class="blue--text mr-2">mdi-cake</v-icon> <span class="blue--text">F. Nacimiento:</span><span :class="`${usuarioFormated.fNacimiento === 'Sin especificar' ? 'red--text' : ''}`"> {{ usuarioFormated.fNacimiento }}</span><br>
                  <v-icon size="18" class="blue--text mr-2">{{usuarioFormated.sexo.icon}}</v-icon> <span class="blue--text">Sexo:</span><span :class="`${usuarioFormated.sexo.text === 'Sin especificar' ? 'red--text' : ''}`"> {{ usuarioFormated.sexo.text }}</span><br>
                  <v-icon size="18" class="blue--text mr-2">mdi-phone</v-icon> <span class="blue--text">Teléfonos:</span><span :class="`${usuarioFormated.telefonos === 'Sin especificar' ? 'red--text' : ''}`"> {{ usuarioFormated.telefonos }}</span><br>
                  <v-icon size="18" class="blue--text mr-2">mdi-wheelchair-accessibility</v-icon> <span class="blue--text">Discapacidad:</span> {{ usuarioFormated.discapacidad }}
                </p>
              </v-card-text>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-btn
                  absolute
                  color="orange"
                  class="white--text"
                  fab
                  large
                  right
                  top
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <h3 :class="`text-xs-center display-1 font-weight-light mb-2 ${hover ? 'red--text' : 'grey--text text--lighten-4'}`">Editar</h3>
              </v-card-text>
            </v-card>
          </v-hover>
          <!-- <v-card>
            <v-card-title>
              Información Personal
            </v-card-title>
            <v-card-text class="px-0">12</v-card-text>
          </v-card> -->
        </v-flex>
      </v-layout>

      <!-- Inmuebles -->
      <v-layout row wrap class="mt-2">
        <v-flex xs12>
          <v-card 
            max-width="600"
            class="mx-auto"
            >
            <v-card-text class="grey--text text--darken-2 font-weight-light">
              <h2 class="headline font-weight-light text-xs-right">Datos Inmueble/s</h2>
              <v-divider></v-divider>
              <p class="new-inmueble headline grey--text font-weight-thin mt-3" @click="nuevoInmueble">
                <v-btn
                  color="success"
                  class="white--text boton-edit"
                  fab
                  small
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                Agregar inmueble
              </p>
              <v-hover
                  v-for="(item, i) in usuarioInmueblesFormated" 
                  :key="i">
                <v-card
                  slot-scope="{ hover }"
                  :class="`mt-3 pointer-card mx-auto elevation-${hover ? 12 : 2}`"
                  :color="`${hover ? 'amber lighten-5' : 'grey lighten-4'}`"
                  max-width="600"
                  @click="inmuebleDataEdit(item.ref)"
                >
                  <v-card-text class="grey--text text--darken-2 font-weight-light">
                    <p class="headline blue--text font-weight-thin mt-3">
                      <v-btn
                        color="orange"
                        class="white--text boton-edit"
                        fab
                        small
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="usuarioInmueblesFormated.length > 1"
                        color="red"
                        class="white--text boton-edit"
                        fab
                        small
                        @click.stop="eliminaInmueble(item.ref)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      {{ i+1 }} : {{ item.ref }}
                    </p>
                    <p style="line-height:29px">
                      {{ item.l1 }}<br>
                      {{ item.l2 }}<br>
                      {{ item.l3 }}<br>
                      <!-- <strong>Personas empadronadas: 0</strong> -->
                    </p>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <Profile :usuario="usuario" formName="formProfile" />
    <Inmueble :inmueble="inmuebleSelect" :usuario="usuario" :formatedInmueble="inmuebleFormated" />

    <!-- Diálogo Nuevo Inmueble -->
    <v-dialog v-model="dialogAddInmueble" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nuevo Inmueble</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span>Seleccione uno de los inmuebles del siguiente listado:</span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="nuevoInmuebleSelect"
                  :items="inmueblesDisponiblesFormat"
                  item-text="text"
                  label="Inmueble"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="agregarNuevoInmueble">Agregar</v-btn>
          <v-btn @click="dialogAddInmueble = false; nuevoInmuebleSelect = null">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { completaNif } from "@/plugins/functions.js";
// import DiscapacidadDialog from "@/components/dialog-discapacidad";
import DiscapacidadPropietario from "@/components/discapacidad-propietario";
import Profile from "./edit-profile";
import Inmueble from "./inmueble-data";
export default {
  components: { DiscapacidadPropietario, Profile, Inmueble },
  data: () => ({
    hola: true,
    isMobile: false,
    step: 1,
    usuario: null,
    phoneItems: [],
    phoneSearch: null,
    refCatItems: [],
    refCatSearch: null,
    fechaNac: {
      dias: [],
      meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      years: []
    },
    checkUser: null,
    openDiscapacidad: false,
    _discapacidad: {
      isDiscapacidad: false,
      tipo: false,
      grado: 0,
      movilidad: false,
      documentoDiscapacidad: false
    },
    refCat: null,
    dialogAddInmueble: false,
    nuevoInmuebleSelect: null
    // usuarioInmueblesFormated: []
  }),
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted() {
    console.log(this.$vuetify.breakpoint);
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    this.autocompleteFecha();
    if (this.copiarDatos) {
      console.log('Copiar datos');
      this.usuarioCopy();
    } else {
      console.log('No copiar datos');
    }
    // this.chequeaUser();
  },
  watch: {
    userProp(newValue) {
      // if (newValue) {
        this.usuarioCopy();
      // }
    },
    copiarDatos(newValue) {
      if (newValue) {
        this.usuarioCopy();
      }
    }/* ,
    changeInmuebles(newValue) {
      if (newValue) {
        // this.usuario.inmueblesList = JSON.parse(JSON.stringify(this.propietario.inmueblesList));
        // this.setChangeInmuebles(false);
        // this.formateaDatos();
      }
    },
    inmueblesPropietario() {
      // this.formateaDatos();
    }, */
    /* numInmuebles() {
      if (!this.usuario) {
        return;
      }
      this.usuario.inmueblesList = this.listaInmuebles;
    } */
  },
  methods: {
    ...mapActions(["saveDataUser", "setMunicipios", "setPropietarioDialog", "setChangeInmuebles", "setNuevoInmueble", "deleteInmueble"]),
    /* chequeaUser() {
      clearInterval(this.checkUser);
      if (this.copiarDatos) {
        this.checkUser = setInterval(this.usuarioCopy(), interval);
      }
    }, */
    eliminaInmueble(refCat) {
      console.log('eliminar: ', refCat);
      this.deleteInmueble(refCat);
    },
    nuevoInmueble() {
      console.log('Nuevo Inmueble');
      this.dialogAddInmueble = null;
      this.dialogAddInmueble = true;
    },
    agregarNuevoInmueble() {
      if (!this.nuevoInmuebleSelect) {
        console.log('Ningún inmueble seleccionado');
        return
      }
      this.setNuevoInmueble(this.inmueblesDisponibles.filter(i => i.refCat === this.nuevoInmuebleSelect)[0]);
      this.dialogAddInmueble = null;
    },
    clickEdit (e) {
      console.log('Clicado: ', e);
      if (e === 'personalData') {
        this.setPropietarioDialog({
          dialog: 'formProfile',
          value: true
        });
      }
    },
    inmuebleDataEdit (e) {
      console.log('Inmueble: ', e);
      this.refCat = e;
      this.setPropietarioDialog({
        dialog: 'formInmueble',
        value: true
      });
    },
    onResize () {
      this.isMobile = window.innerWidth < 600
    },
    changeDiscap(e) {
      // console.log(e);
      this.usuario.discapacidad = e;
    },
    stepPlus() {
      if (this.changeData) {
        this.saveDataUser(this.usuario);
      }
      this.step++
    },
    usuarioCopy() {
      console.log("copiando...");
      this.usuario = JSON.parse(this.userProp);
      // this.usuario.inmueblesList = this.inmueblesPropietario;
      /* if (this.usuario.inmuebles) { // 4252302XH6045S0004WB
        if (!Array.isArray(this.usuario.inmuebles)) {
          this.usuario.inmuebles = Object.keys(this.usuario.inmuebles)
        }
      } */
      if (this.usuario.direccion.provincia) {
        this.changeProvincia();        
      }
    },
    forceUppercase(e, o, prop) {
      // this.aaa = e
      if (prop === "nif" && o.nif.length === 8) {
        this.$set(o, prop, completaNif(o.nif));
        return;
      }
      //https://forum.vuejs.org/t/inputs-always-in-uppercase-using-v-model/7450/9
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },
    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    changeProvincia() {
      this.setMunicipios(this.usuario.direccion.provincia);
    },
    autocompleteFecha() {
      const actualYear = new Date().getFullYear();
      const rango = 120;
      this.fechaNac.years = [];
      for (let index = actualYear; index > actualYear - rango; index--) {
        this.fechaNac.years.push(index);
      }
      this.fechaNac.dias = [];
      for (let index = 1; index < 32; index++) {
        this.fechaNac.dias.push(index);
      }
    },
    localidadTranslate (idx) {
      return this.getMunicipiosSelect.filter(i => i.value === idx).map(i => i.text)[0] || '';
    },
    provinciaTranslate (idx) {
      return this.getProvinciasSelect.filter(i => i.value === idx).map(i => i.text)[0] || '';
    },
    formateaDatos() {
      return;
      if (!this.inmueblesPropietario) {
        this.usuarioInmueblesFormated = [];
        return;
      }
      const dataFormat = this.usuarioInmueblesFormated.map(i => {
          let comunidad = i.direccion.nombreComunidad || '';
          comunidad = comunidad.length > 1 ? `(${comunidad}), ` : '';
          const ubica = i.inmuebleData ? ` Escalera: ${i.inmuebleData.escalera || '?'}, Piso: ${i.inmuebleData.piso || '?'}, Letra: ${i.inmuebleData.letra || '?'}` : '';
          return {
              id: i.customId,
              expte: i.expte,
              ref: i.inmuebleData.refCat,
              l1: `${i.direccion.ca.name.toUpperCase()} / ${this.provinciaTranslate(i.direccion.provincia)} / ${i.direccion.cp || ''} - ${this.localidadTranslate(i.direccion.localidad)}`,
              l2: `${comunidad}${i.direccion.dir}`,
              l3: `(${i.inmuebleData.direccion})${ubica}`
            }
        });
      this.usuarioInmueblesFormated = JSON.parse(JSON.stringify(dataFormat));
    },
    formateaDatos_old() {
      if (!this.usuario || !this.usuario.inmueblesList) {
        this.usuarioInmueblesFormated = [];
        return;
      }
      const dataFormat = this.usuario.inmueblesList.map(i => {
          let comunidad = i.direccion.nombreComunidad || '';
          comunidad = comunidad.length > 1 ? `(${comunidad}), ` : '';
          const ubica = i.inmuebleData ? ` Escalera: ${i.inmuebleData.escalera || '?'}, Piso: ${i.inmuebleData.piso || '?'}, Letra: ${i.inmuebleData.letra || '?'}` : '';
          return {
              id: i.customId,
              expte: i.expte,
              ref: i.inmuebleData.refCat,
              l1: `${i.direccion.ca.name.toUpperCase()} / ${this.provinciaTranslate(i.direccion.provincia)} / ${i.direccion.cp || ''} - ${this.localidadTranslate(i.direccion.localidad)}`,
              l2: `${comunidad}${i.direccion.dir}`,
              l3: `(${i.inmuebleData.direccion})${ubica}`
            }
        });
      this.usuarioInmueblesFormated = JSON.parse(JSON.stringify(dataFormat));
    }
  },
  computed: {
    ...mapGetters(["propietario", "getProvinciasSelect", "getMunicipiosSelect", "inmueblesPropietario", "changeInmuebles", "inmueblesDisponibles"]),
    inmueblesDisponiblesFormat() {
      if (!this.inmueblesDisponibles) {
        return [];
      }
      let result = [];
      this.inmueblesDisponibles.forEach(item => {
        result.push({
          text: item.direccion,
          value: item.refCat
        });
      });
      return result;
    },
    inmuebleFormated() {
      if (!this.refCat) {
        return null;
      }
      return this.usuarioInmueblesFormated.filter(i => i.ref === this.refCat)[0];
    },
    listaInmuebles() {
      if (this.propietario) {
        return this.propietario.inmueblesList || [];
      }
      return [];
    },
    numInmuebles() {
      return this.listaInmuebles.length;
    },
    inmuebleSelect() {
      if (!this.refCat || !this.inmueblesPropietario) {
        return null;
      }
      return this.inmueblesPropietario.filter(i => i.inmuebleData.refCat === this.refCat)[0];
    },
    inmuebleSelect_old() {
      if (!this.refCat || !this.usuario || !this.usuario.inmueblesList) {
        return null;
      }
      return this.usuario.inmueblesList.filter(i => i.inmuebleData.refCat === this.refCat)[0];
    },
    discapacidad() {
      if (this.usuario.discapacidad) {
        return Object.assign({}, this._discapacidad, this.usuario.discapacidad)
      }
      return this._discapacidad;
    },
    usuarioLocalidad () {
      if (!this.usuario || !this.usuario.direccion || !this.usuario.direccion.localidad) {
        return '';
      }
      // return this.getMunicipiosSelect.filter(i => i.value === this.usuario.direccion.localidad).map(i => i.text)[0] || '';
      return this.localidadTranslate(this.usuario.direccion.localidad);
    },
    usuarioProvincia () {
      if (!this.usuario || !this.usuario.direccion || !this.usuario.direccion.provincia) {
        return '';
      }
      // return this.getProvinciasSelect.filter(i => i.value === this.usuario.direccion.provincia).map(i => i.text)[0] || '';
      return this.provinciaTranslate(this.usuario.direccion.provincia);
    },
    usuarioFormated () {
      if (!this.usuario) {
        return null
      }
      let tlf = this.usuario.tlf1 || '';
      if (this.usuario.tlf && this.usuario.tlf.length > 0) {
        this.usuario.tlf.forEach(element => {
          tlf += `, ${element}`
        });
      }
      tlf = tlf.length > 0 ? tlf : 'Sin especificar';
      let fnac = !!this.usuario.fechaNacimientoDia && !!this.usuario.fechaNacimientoMes && !!this.usuario.fechaNacimientoYear;
      fnac = fnac ? `${this.usuario.fechaNacimientoDia || ''} / ${this.usuario.fechaNacimientoMes} / ${this.usuario.fechaNacimientoYear}` : 'Sin especificar';
      let nif = !!this.usuario.nif;
      nif = nif ? this.usuario.nif : 'Sin especificar'
      let ncompleto = !!this.usuario.nombre || !!this.usuario.apellido1 || !!this.usuario.apellido2;
      ncompleto = ncompleto ? `${this.usuario.nombre} ${this.usuario.apellido1} ${this.usuario.apellido2}` : 'Sin especificar';
      ncompleto = ncompleto.replace(/undefined/g, '').trim();
      let dire = !!this.usuario.direccion.calle || !!this.usuarioLocalidad || this.usuarioProvincia;
      dire = dire ? `${this.usuario.direccion.calle}, ${this.usuario.direccion.cp}, ${this.usuarioLocalidad}, ${this.usuarioProvincia}` : 'Sin especificar';
      dire = dire.replace(/undefined, |, undefined/g, '').trim();
      let sex = !!this.usuario.sexo
      sex = sex ? this.usuario.sexo > 1 ? {text: 'Mujer', icon: 'mdi-gender-female'} : {text: 'Hombre', icon: 'mdi-gender-male'} : {text: 'Sin especificar', icon: 'mdi-gender-transgender'}
      const discap = this.usuario.discapacidad || false;
      let disc = discap ? discap.isDiscapacidad : false;
      disc = !disc ? 'Ninguna especificada' : `Tipo: ${discap.tipo}, Grado: ${discap.grado}`;
      return {
        nombre: ncompleto,
        direccion: dire,
        fNacimiento: fnac,
        telefonos: tlf,
        nif: nif,
        sexo: sex,
        discapacidad: disc
      }
    },
    usuarioInmueblesFormated() {
      if (!this.inmueblesPropietario) {
        return [];
      }
      const dataFormat = this.inmueblesPropietario.map(i => {
        let comunidad = i.direccion.nombreComunidad || '';
        comunidad = comunidad.length > 1 ? `(${comunidad}), ` : '';
        const ubica = i.inmuebleData ? ` Escalera: ${i.inmuebleData.escalera || '?'}, Piso: ${i.inmuebleData.piso || '?'}, Letra: ${i.inmuebleData.letra || '?'}` : '';
        return {
            id: i.customId,
            expte: i.expte,
            ref: i.inmuebleData.refCat,
            l1: `${i.direccion.ca.name.toUpperCase()} / ${this.provinciaTranslate(i.direccion.provincia)} / ${i.direccion.cp || ''} - ${this.localidadTranslate(i.direccion.localidad)}`,
            l2: `${comunidad}${i.direccion.dir}`,
            l3: `(${i.inmuebleData.direccion})${ubica}`
          }
      });
      return JSON.parse(JSON.stringify(dataFormat));
    },
    /* usuarioInmueblesFormated_old () {
      if (this.usuario && this.usuario.inmueblesList) {
        return this.usuario.inmueblesList.map(i => {
          let comunidad = i.direccion.nombreComunidad || '';
          comunidad = comunidad.length > 1 ? `(${comunidad}), ` : '';
          const ubica = i.inmuebleData ? ` Escalera: ${i.inmuebleData.escalera || '?'}, Piso: ${i.inmuebleData.piso || '?'}, Letra: ${i.inmuebleData.letra || '?'}` : '';
          return {
              id: i.customId,
              expte: i.expte,
              ref: i.inmuebleData.refCat,
              l1: `${i.direccion.ca.name.toUpperCase()} / ${this.provinciaTranslate(i.direccion.provincia)} / ${i.direccion.cp || ''} - ${this.localidadTranslate(i.direccion.localidad)}`,
              l2: `${comunidad}${i.direccion.dir}`,
              l3: `(${i.inmuebleData.direccion})${ubica}`
            }
        });
      }
    }, */
    copiarDatos() {
      if (this.propietario && !this.usuario) {
        return true;
      }
      return false;
    },
    changeData() {
      return !Object.is(JSON.stringify(this.usuario), JSON.stringify(this.propietario));
    },
    userProp() {
      if (!this.propietario || typeof this.propietario !== 'object') {
        return null;
      }
      return JSON.stringify(this.propietario);
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Datos personales";
        case 2:
          return "Dirección";
        case 3:
          return "Teléfono/s de contacto";
        case 4:
          return "Fecha de nacimiento";
        case 5:
          return "Inmuebles";
        default:
          return "Otros datos";
      }
    }
  }
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.pointer-card {
  cursor: pointer;
}
.boton-edit {
  z-index: 3 !important;
}
.new-inmueble {
  cursor: pointer;
}
.new-inmueble:hover {
  color: rgb(79, 157, 180) !important;
}
</style>
